export const config = {
    name: 'failList',
    searchFields: [
        {
            name: '事件',
            value: 'eventCode',
            isFixed: true,
            optionNum: 'LCRM_EVENT',
            type: 'select',
            span: 3
        },
        {
            name: '关键参数',
            placeholder: '参数1-5',
            value: 'keyword',
            isFixed: true,
            type: 'input',
            span: 3
        }

    ],
    selection: false,
    index: false,
    tableData: {
        columns: [
            {
                label: '事件',
                prop: 'eventCode',
                type: 'select',
                optionsKey: 'LCRM_EVENT',
                minWidth: 160
            },
            // {
            //     label: '备注',
            //     prop: 'remark',
            //     minWidth: 150
            // },
            {
                label: '参数1',
                prop: 'param1',
                minWidth: 140
            },
            {
                label: '参数2',
                prop: 'param2',
                minWidth: 140
            },
            {
                label: '参数3',
                prop: 'param3',
                minWidth: 140
            },
            {
                label: '参数4',
                prop: 'param4',
                minWidth: 140
            },
            {
                label: '参数5',
                prop: 'param5',
                minWidth: 140
            },
            {
                label: '鹊桥日志链接',
                prop: 'magpieBridgeLink',
                minWidth: 140
            },
            {
                label: '接口错误报文',
                prop: 'errorMessage',
                minWidth: 150
            },
            {
                label: '创建人MIP',
                prop: 'createUserCode',
                minWidth: 100
            },
            {
                label: '创建时间',
                prop: 'createTime',
                minWidth: 150
            },
            {
                label: '更新人MIP',
                prop: 'updateUserCode',
                minWidth: 100
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                minWidth: 150
            }
        ]
    },
    PANELMAX: 8,
    LASTFOUR: 4,
    LASTSIX: 6,
    actions: { // 表格操作列的配置
        fixedWidth: 80, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
        ]
    }
};
